import { ReactComponent as SettingIconSVG } from "./setting-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconSetting(props) {
  return <SvgIcon {...props} component={SettingIconSVG} viewBox="0 0 20 19" />;
}